<script lang="ts">
  import type { Spot } from "$lib/elev8Api/contentTypes";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";
  import { domainAndFileFromUrl } from "$lib/utils/urlUtils";
  import { SOURCE_VERSION } from "virtual:source-version";

  interface Props {
    spot?: Spot;
  }

  let { spot }: Props = $props();
  const config = getConfigurationContext();
</script>

<div
  class="absolute right-3 top-20 *:font-mono *:bg-slate-200/75 *:px-1 *:text-xs text-black z-50"
>
  <p class="font-semibold">screen</p>
  {#each Object.entries(config.screen ?? {}) as [key, value]}
    <p>
      >> {key}: {key === "property_logo_url" && value
        ? domainAndFileFromUrl(String(value), true)
        : value}
    </p>
  {/each}
  <p class="font-semibold">content (idx|content_type|mime)</p>
  {#each spot?.contents ?? [] as content, i}
    <p>
      >> {i} | {content.content_type} | {content.mime_type ?? "n/a"}
    </p>
  {/each}
  <p class="font-semibold">env</p>
  {#if import.meta.env.VITE_LOGGER_BIND_CONSOLE === "true"}
    <p class="text-red-600">>> VITE_LOGGER_BIND_CONSOLE=true</p>
  {/if}
  <p>>> v.{SOURCE_VERSION?.slice(0, 7) ?? "?"}</p>
</div>
